import React from "react";
import { isWeekend } from "../../../common/util";
import { todayInSydney } from "../../../common/clock";
import { DayModifiers } from "react-day-picker";
import Tooltip from "rc-tooltip";

interface RentalDatePickerDayProps {
  date: Date;
  modifiers?: DayModifiers;
}

export class RentalDatePickerDay extends React.Component<RentalDatePickerDayProps> {
  static defaultProps = {
    modifiers: { disabled: false }
  };

  constructor(props: RentalDatePickerDayProps) {
    super(props);
  }

  shouldComponentUpdate(nextProps: RentalDatePickerDayProps) {
    const dateDiffer = nextProps.date.toDateString() !== this.props.date.toDateString();
    let modifiersDiffer = true;

    if (nextProps.modifiers && this.props.modifiers) {
      modifiersDiffer = nextProps.modifiers.disabled !== this.props.modifiers.disabled;
    }

    return dateDiffer || modifiersDiffer;
  }

  render() {
    const tooltipText = this._tooltipText();
    const dayContent = <div className="DayPicker-Day__content">{this.props.date.getDate()}</div>;
    if (tooltipText) {
      return (
        <Tooltip
          overlayStyle={{ zIndex: 9999999 }}
          placement="top"
          overlay={tooltipText}
          destroyTooltipOnHide={true}
          mouseLeaveDelay={0}
        >
          {dayContent}
        </Tooltip>
      );
    } else {
      return dayContent;
    }
  }

  _tooltipText() {
    if (this.props.modifiers && !this.props.modifiers.disabled) {
      return null;
    }

    const date = this.props.date;
    const today = todayInSydney();
    const tomorrow = today.add(1, "day");

    if (tomorrow.isSame(date, "day")) {
      return (
        <span>
          Next day delivery is only available in capital cities. <br />
          Order must be placed before 3:00PM AEST.
        </span>
      );
    }

    if (isWeekend(date)) {
      return <span>No deliveries on weekends</span>;
    }

    if (today.isSame(date, "day")) {
      return (
        <span>
          Same day delivery is only available in Sydney metro area. <br />
          Order must be placed before 3:00PM AEST.
        </span>
      );
    }

    return (
      <span>
        Grey dates: Unavailable
        <br />
        White dates: Available
      </span>
    );
  }
}
